export default "__VITE_ASSET__wceJkrv4__"